export default __webpack_public_path__ + "static/role-d1c8f22202a5e5b0e55b5ecc82200116.png";